module.exports = __webpack_public_path__ + "static/media/epic.87581b11.jpg";